import { useEffect } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Index from "./pages/Index";
import Solutions from "./pages/Solutions";
import MusicDetail from "./pages/MusicDetail";
import Exhibition from "./pages/Exhibition";
import MerchDetail from "./pages/MerchDetail";
import Videos from "./pages/Videos";
import VideoDetail from "./pages/VideoDetail";
import Tour from "./pages/Tour";
import TourDetail from "./pages/TourDetail";
import Info from "./pages/Info";
import NotFound from "./pages/NotFound";
import Privacy from "./components/Privacy";
import Thankyou from "./pages/Thankyou"
import Portable from "./pages/Portable"


// New Imports
import Warehousing from "./pages/Warehousing";
import Labour from "./pages/Labour";
import Sales from "./pages/Sales";
import Gallery from "./pages/Gallery";
import Events from "./pages/Events";
import Sports from "./pages/Sports";

import { Analytics } from "@vercel/analytics/next"
import { SpeedInsights } from "@vercel/speed-insights/next"

const queryClient = new QueryClient();

const App = () => {
  useEffect(() => {
    // Google Tag Manager - Head Script
    const script = document.createElement("script");
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-THJC5JZR');
    `;
    document.head.appendChild(script);

    // Google Tag Manager - Body (noscript) Script
    const noscript = document.createElement("noscript");
    noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-THJC5JZR"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
    document.body.insertBefore(noscript, document.body.firstChild);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/music/:id" element={<MusicDetail />} />
            <Route path="/exhibition" element={<Exhibition />} />
            <Route path="/events" element={<Events />} />
            <Route path="/merch/:id" element={<MerchDetail />} />
            
            {/* New Routes */}
            <Route path="/warehousing" element={<Warehousing />} />
            <Route path="/labour" element={<Labour />} />
            <Route path="/sales" element={<Sales />} />
            <Route path="/sports" element={<Sports />} />
            

            <Route path="/videos" element={<Videos />} />
            <Route path="/videos/:id" element={<VideoDetail />} />
            <Route path="/portable" element={<Portable />} />
            <Route path="/tour/:id" element={<TourDetail />} />
            <Route path="/contact" element={<Info />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/thankyou" element={<Thankyou />} />
          </Routes>
          
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;